"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigData = getConfigData;
exports["default"] = void 0;

var _immer = _interopRequireDefault(require("immer"));

var _model = _interopRequireDefault(require("../model"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line no-mixed-requires


var deepmerge = require("deepmerge");

var defaults = require("../defaults.json");

var initialState = {};
/* eslint-disable no-unused-vars, prefer-reflect */

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return (0, _immer["default"])(state, function (draft) {
    if (Object.getOwnPropertyNames(state).length > 0) {
      return state;
    }

    var configArray = getConfigData();
    var obj = new _model["default"](configArray);
    return obj;
  });
};

exports["default"] = _default;

function getConfigData() {
  var configArray = defaults;

  if (window.overrides_data) {
    configArray = deepmerge(configArray, window.overrides_data);
  }

  return configArray;
}